import React, { useEffect } from 'react'
import Layout from "../../NewComponent/LayoutExpert/Layout";
import QuestionBox from './QuestionBox';
import GenAIBox from './GenAIBox';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { fetchSearchResult } from '../../API/api';
import { replaceVIZERTOPERText } from '../../utils';
import { Actions } from "../../Action";
import Tabs from './Tabs';
import KeyTagDataBox from '../KeyTermPage/KeyTagDataBox';

export default function NewSearchExpertpage() {
  const dispatch = useDispatch();
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const domainState = useSelector((state) => state.domain);
  const keyTagState = useSelector(state=>state.keyTag);
  const { textparam, isAsk } = useParams();
  const {
    searchInputValue,
    updateSearchData,
    searchDataLoading,
    getExpertProfilePics,
    updateSearchData2,
    searchDocSourceFilterUpdate,
    updateAskTheTeamStatus,
    UpdateGenerativeAITextWhenAPICall,
    allScrolledAnswerUuid,
    isShowResultsCPR,
    sidebarOpenSP
  } = bindActionCreators(Actions, dispatch);
  const container = {
    // width: "74%",
    // margin: "auto",
    marginTop: "3%",
    // marginBottom: "7%",
    border: "1px solid #E0E2E6",
    background: "#FFFFFF",
    borderRadius: "12px",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "28px",
  };
  const fetchData = ()=>{
    searchInputValue(replaceVIZERTOPERText(decodeURIComponent(textparam)));
    UpdateGenerativeAITextWhenAPICall({name:'empty'});
    allScrolledAnswerUuid([]);
    updateSearchData2(null);
    updateSearchData([]);
    searchDataLoading(true);
    let payload = {
      question: replaceVIZERTOPERText(decodeURIComponent(textparam)),
      domains: domainState.selectedDomain,
      type: "Vizerto",
      origQuestionUuid: "",
      spellCheckFlag: false,
      searchmethod: userState.searchToggle? "bert" : "w2v",
    }
    fetchSearchResult(
      payload,
      updateSearchData,
      getExpertProfilePics,
      updateSearchData2
    );
  }
  useEffect(()=>{
    fetchData();
  },[textparam]);
  return (
    <>
    <Layout>
        <div style={{ width: "74%", margin: "auto", marginTop: "1%", marginBottom:'7%' }}>
            <QuestionBox/>
            {!keyTagState.isBack && <GenAIBox/>}
            {!keyTagState.isBack && !searchState.isLoading && searchState.origSearchData.length !== 0 && <Tabs/>}
            {keyTagState.isBack && <div style={container}><KeyTagDataBox/></div>}
        </div>
    </Layout>
    </>
  )
}
